import {
	CSV_FORMAT,
	IMPORT_REPORT_TYPE,
	NON_EU_IMPORT_REPORT_TYPE,
	NON_UNION_REPORT_TYPE,
	SPECIAL_FORMAT,
	UNION_REPORT_TYPE,
} from 'redux/reducers/reports/constants';
import { downloadVatReportRequest } from 'redux/reducers/reports/reducer';
import {
	TDownloadVatReportsFileFormat,
	TGetVatReportsResponseRowsItem,
	TVatReportsEmData,
	TVatReportTypes,
} from 'redux/reducers/reports/types';

export type TVatReportDownloadButton = TDownloadVatReportsFileFormat | typeof SPECIAL_FORMAT;

// Some reporting countries require their own file format
export const getSpecFormat = (
	reportType: TVatReportTypes,
	emData: TVatReportsEmData | undefined,
): TDownloadVatReportsFileFormat | null => {
	const countryCode =
		reportType === IMPORT_REPORT_TYPE
			? emData?.iossImportSchemeRegisteredCountryCode
			: reportType === UNION_REPORT_TYPE
				? emData?.iossUnionSchemeRegisteredCountryCode
				: reportType === NON_UNION_REPORT_TYPE
					? emData?.iossNonUnionSchemeRegisteredCountryCode
					: null;

	if (countryCode === 'FI' || countryCode === 'DE') return 'csv';
	if (countryCode === 'SE') return 'txt';
	if (countryCode === 'EE') return 'xml';
	return null;
};

const FILE_NAME_PREFIX: Record<TVatReportTypes, string> = {
	[IMPORT_REPORT_TYPE]: 'vat_report_import',
	[UNION_REPORT_TYPE]: 'vat_report_union',
	[NON_UNION_REPORT_TYPE]: 'vat_report_non_union',
	[NON_EU_IMPORT_REPORT_TYPE]: 'vat_report_non_eu',
};

const getFileName = (
	reportType: TVatReportTypes,
	report: TGetVatReportsResponseRowsItem,
	format: TDownloadVatReportsFileFormat,
) => {
	const period =
		reportType === UNION_REPORT_TYPE || reportType === NON_UNION_REPORT_TYPE
			? `Q${report.quarter ?? 1}`
			: `${report.month ?? 1}`;
	const extension = format === CSV_FORMAT ? 'zip' : format;

	return `${FILE_NAME_PREFIX[reportType]}__${report.year}-${period}.${extension}`;
};

export const getDownloadVatReportAction = (
	reportType: TVatReportTypes,
	report: TGetVatReportsResponseRowsItem,
	button: TVatReportDownloadButton,
	specFormat: TDownloadVatReportsFileFormat | null,
) => {
	const format =
		reportType === NON_EU_IMPORT_REPORT_TYPE
			? CSV_FORMAT
			: button === SPECIAL_FORMAT
				? specFormat
				: button;
	if (!format) return null;

	return downloadVatReportRequest({
		reportType,
		reportId: report.id,
		format,
		fileName: getFileName(reportType, report, format),
	});
};
